import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs, Tab, Row, Col, Card, Accordion, Button } from 'react-bootstrap';
import { DASHBOARD_TAB_KEY, STATE_STATUS, DASHBOARD_QUALITY_COLOURS } from '@awp/constants';
import { currentDashboardViews } from '@stores/avalancheDashboardViewPageSlice';
import { isValueEmpty, isValueNotEmpty, isInt, isMatchArray } from '@awp/helpers/utilsReact';
import DetailQualityTable from '@awp/components/AvalancheMonitor/GraphView/DetailQualityTable';
import PropTypes from 'prop-types';

const pstyle = {
  cursor: 'pointer',
};
const pStIconStyle = {
  cursor: 'pointer',
  paddingLeft: '8px',
  paddingRight: '8px',
};

const DetailQualityView = ({ id, area }) => {
  console.log(area);
  const [tabKey, setTabKey] = useState(DASHBOARD_TAB_KEY.TABLE);
  const [isStCollapsed, setIsStCollapsed] = useState(false);
  const dashboardViews = useSelector(currentDashboardViews);
  const [requestDto, setRequestDto] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!dashboardViews) return;
    let _dashboardViews = { ...dashboardViews };
    let _qualityDetails = _dashboardViews.QualityDashboardViews;
    if (!_qualityDetails) return;
    let _details = _qualityDetails
      .filter((item) => item.AreaId === area.AreaId)
      .sort((a, b) => {
        return a.EventChronologicalOrder > b.EventChronologicalOrder
          ? -1
          : a.EventChronologicalOrder < b.EventChronologicalOrder
          ? 1
          : 0;
      });
    console.log(_details);
    setRequestDto(_details);
  }, [dashboardViews, area]);

  const setStIconCollapse = () => {
    setIsStCollapsed(!isStCollapsed);
  };
  const convertPecentage = (colors, idx) => {
    // Green // Red
    if (colors) {
      let green = isInt(colors[0]) ? Number(colors[0]) : 0;
      let red = isInt(colors[1]) ? Number(colors[1]) : 0;

      let total = green + red;
      if (total === 0) {
        return 0;
      } else {
        let greenPercent = Math.round((green / total) * 100);
        let redPercent = Math.round((red / total) * 100);
        let data = [greenPercent, redPercent];
        return data[idx] === 0 ? 0 : data[idx] + '%';
      }
    }
    return 0;
  };
  return (
    <>
      {area && (
        <Card border="light" className="page-card" style={{ marginTop: '0' }}>
          <Card.Body>
            <Row>
              <Col lg={7} md={7}>
                {isStCollapsed ? (
                  <span style={pstyle} onClick={setStIconCollapse}>
                    <i className="fa fa-caret-down" style={{ color: '#003366' }} />
                  </span>
                ) : (
                  <span style={pstyle} onClick={setStIconCollapse}>
                    <i className="fa fa-caret-right" style={{ color: '#003366' }} />
                  </span>
                )}
                <span
                  className="font-weight-bold"
                  style={{ cursor: 'pointer', fontSize: '0.8rem', paddingLeft: '0.4rem' }}
                  onClick={setStIconCollapse}
                >
                  {area.AreaLabel}
                </span>
              </Col>

              <Col lg={5} md={5} style={{ paddingLeft: '0', paddingRight: '0' }}>
                <button
                  type="button"
                  className="btn btn-sm text-white"
                  style={{
                    backgroundColor: `${DASHBOARD_QUALITY_COLOURS[0]}`,
                    fontSize: '0.78rem',
                    marginRight: '0.4rem',
                  }}
                >
                  {convertPecentage(area.QualityColors, 0)}
                </button>
                <button
                  type="button"
                  className="btn btn-sm text-white"
                  style={{
                    backgroundColor: `${DASHBOARD_QUALITY_COLOURS[1]}`,
                    fontSize: '0.78rem',
                    marginRight: '0.4rem',
                  }}
                >
                  {convertPecentage(area.QualityColors, 1)}
                </button>
              </Col>
            </Row>
            {isStCollapsed && (
              <>
                <Tabs
                  id="dashboard-details-tabs"
                  activeKey={tabKey}
                  onSelect={(k) => setTabKey(k)}
                  className="mb-3 tab"
                  style={{ fontSize: '0.7rem' }}
                  transition={false}
                >
                  {/* <Tab eventKey={DASHBOARD_TAB_KEY.GRAPH} title="Graph"></Tab> */}
                  <Tab eventKey={DASHBOARD_TAB_KEY.TABLE} title="Table"></Tab>
                </Tabs>
                <div className="graph__container">
                  <Row>
                    <Col md={12}>
                      <div style={{ fontSize: '0.7rem' }}>
                        {isStCollapsed && requestDto && (
                          <DetailQualityTable
                            idx={`tbl_log_${area.AreaId}`}
                            requestDTO={requestDto}
                            convertPecentage={convertPecentage}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}
    </>
  );
};

DetailQualityView.propTypes = {
  //weatherStationId: PropTypes.any.isRequired,
};

export default DetailQualityView;
